import NotixLoggerService from "Services/logger";

export default function onError(msg, url, lineNo, columnNo, error) {
  let body = {
    message: msg,
    name: document.location.href,
    code: error?.code,
    stack: error?.stack,
  };

  NotixLoggerService.logError(body);

  return true;
}
